import React, { useEffect, useState } from "react";
import api from "../api";
import ServiceCard from "../components/ServiceCard";
import SignaturePhrase from "../components/SignaturePhrase";
import { SectionTitle, usePageSeo } from "../components/common";

export default function Guidances() {
  usePageSeo({
    title: "Mes tirages intuitifs",
    description: "Les tirages intuitifs de Noëmie, à distance : SOS Sorcière, L'Éclair, La Guidance, La Traversée. Cartes, intuition et ressentis, avec compte rendu écrit.",
    path: "/guidances",
  });
  const [services, setServices] = useState([]);
  useEffect(() => {
    api.get("/services?category=guidance").then((r) => setServices(r.data)).catch(() => {});
  }, []);
  return (
    <div className="home-dark min-h-[80vh]">
      <div className="container-x py-12 sm:py-20 fade-up">
        <SectionTitle
          eyebrow="Tirages intuitifs & oracles"
          title="Mes tirages intuitifs"
          sub="Choisis le temps qui te correspond. Aucun appel, aucune visio — je me consacre pleinement à ta séance et tu reçois ton compte rendu par WhatsApp ou e-mail."
        />
        <SignaturePhrase className="mt-8" />
        <div className="mt-10 grid gap-5 sm:grid-cols-2">
          {services.map((s) => (
            <ServiceCard key={s.slug} service={s} />
          ))}
        </div>
      </div>
    </div>
  );
}
